import angular from 'angular';

angular.module('cxTranslations').factory('translateSvc', ['$http', 'appUrls', translateSvc]);

function translateSvc($http, appUrls) {
  var getLabels = function(languages) {
    return $http
      .get(appUrls.api + '/api/translationTool/labels/' + languages.join(';'))
      .then(handleSuccess);
  };
  var saveLabel = function(language, key, value) {
    return $http
      .put(appUrls.api + '/api/translationTool/labels/', [
        {
          language: language,
          key: key,
          value: value,
        },
      ])
      .then(handleSuccess);
  };
  var removeLabel = function(key, defs) {
    return $http
      .post(appUrls.api + '/api/translationTool/removeLabel/' + (defs ? '1' : '0'), {
        key: key,
      })
      .then(handleSuccess);
  };
  var getLists = function(languages) {
    return $http
      .get(appUrls.api + '/api/translationTool/lists/' + languages.join(';'))
      .then(handleSuccess);
  };
  var saveList = function(language, key, value) {
    return $http
      .put(appUrls.api + '/api/translationTool/lists/', [
        {
          language: language,
          key: key,
          value: value,
        },
      ])
      .then(handleSuccess);
  };
  var removeList = function(key, defs) {
    return $http
      .post(appUrls.api + '/api/translationTool/removeList/' + (defs ? '1' : '0'), {
        key: key,
      })
      .then(handleSuccess);
  };
  /*var languages = function(all) {
    return $http
      .get(appUrls.api + '/api/translation/language/' + (all ? '1' : '0'))
      .then(handleSuccess);
  };*/

  function handleSuccess(response) {
    return response.data;
  }

  return {
    getLabels: getLabels,
    saveLabel: saveLabel,
    removeLabel: removeLabel,
    getLists: getLists,
    saveList: saveList,
    removeList: removeList,
    languages: ['nl', 'nl-nl', 'fr', 'en'],
  };
}
